// 物件一覧
const Property = {
  namespaced: true,

  state: {
    property: null,
  },
  getters: {
    getProperty: state => {
      return state.property
    },
  },
  mutations: {
    setProperty(state, property) {
      state.property = property
    },
  },
  actions: {
    reset({ commit }) {
      commit('setProperty', null)
    },
  },
}

export default Property
